import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import { tabulation, customPaging, gmToolNewPage, gmTool } from "@/mixins/index";
import { getResoceDetail } from "@/api/dataAll/reesouceDetail";
import { serverList } from "@/api/gmtool/packageCode";
import { serverList as hdServerList } from "@/api/gmtool/packageCode";
import { serverList as yjServerList } from "@/api/gmToolNew/gmToolNew";
export default {
  name: "resourceProDetail",
  mixins: [tabulation, customPaging, gmToolNewPage, gmTool],
  data: function data() {
    return {
      value1: [],
      value2: [],
      total: 0,
      searchData: {
        resource_id: "",
        action: "",
        user_id_str: "",
        device_id_str: "",
        role_id: "",
        page_size: 10,
        page: 1
      },
      tableData: [],
      exportLoading: false,
      userList: [{
        label: this.$t('allUsers'),
        value: 'all'
      }, {
        label: this.$t('payingUsers'),
        value: 'paying'
      }, {
        label: this.$t('nonPayingUsers'),
        value: 'not_paying'
      }],
      costOroutput: [{
        label: this.$t('costLabel'),
        value: '2'
      }, {
        label: this.$t('resourceOutputLabel'),
        value: '1'
      }],
      currentPage: 1
    };
  },
  computed: _objectSpread({}, mapState("d2admin", {
    severlist: function severlist(state) {
      return state.user.GMauthority;
    }
  })),
  created: function created() {
    this.searchData.env_id = this.szgmEnv.length ? this.szgmEnv[0].id : '';

    if (this.rawData.game_mark.indexOf('yjfm') == -1) {
      this.getServer();
    }
  },
  methods: {
    searchClick: function searchClick(e) {
      var _this = this;

      this.searchData.activation_time = "";
      this.searchData.activation_endtime = "";

      if (this.value2 && Array.isArray(this.value2) && this.value2.length > 0) {
        this.searchData.starttime = this.value2[0];
        this.searchData.endtime = this.value2[1];
      }

      if (this.value1 && Array.isArray(this.value1) && this.value1.length > 0) {
        this.searchData.activation_time = this.value1[0];
        this.searchData.activation_endtime = this.value1[1];
      } else {
        this.searchData.activation_time = "";
        this.searchData.activation_endtime = "";
      }

      this.searchData.device_id = this.searchData.device_id_str;
      this.searchData.user_id = this.searchData.user_id_str;
      this.searchData.server_id = this.paramsData.server_id;
      this.searchData.page = e;
      this.reqLoading = true;
      getResoceDetail(this.searchData).then(function (res) {
        console.log("res===", res);

        if (res.status == 200) {
          res.data.length && res.data.forEach(function (item) {
            item.timestamp = _this.$times.timestampToTime(item.timestamp);
          });
          _this.tableData = res.processedData || [];
          _this.total = res.data.total || 0; // let newData = res.data || [];
          // this.currentPage = 1
          // this.tableCopyTableList = JSON.parse(JSON.stringify(newData))
          // this.tableData = this.currentChangePage(this.pageSize, this.currentPage)
          // this.total = res.data.total || 0;

          _this.$nextTick(function () {
            _this.getTableRight();
          });
        }
      }).finally(function () {
        _this.reqLoading = false;
      });
    },
    exportAll: function exportAll() {
      var _this2 = this;

      return new Promise( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(resolve, reject) {
          var queue, query;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  queue = []; // let datesList = []
                  // let page = 1
                  // let pageTotal = 1

                  _context.next = 3;
                  return getResoceDetail(_objectSpread(_objectSpread({}, _this2.searchData), {}, {
                    page_size: -1,
                    page: 1
                  }));

                case 3:
                  query = _context.sent;

                  if (query.status == 200) {
                    // pageTotal = query.data.last_page
                    queue = query.data.data;
                  } else {
                    reject();
                  } // for (let i = 0; i < pageTotal; i++) {
                  //   if (i > 0) {
                  //     // queue.push(getResoceDetail({ ...this.searchData, page_size: 20000, page: i + 1 }))
                  //     let q = await getResoceDetail({ ...this.searchData, page_size: 10000, page: i + 1 })
                  //     if (q.status == 200) {
                  //       queue = [...queue,...q.data.data]
                  //     }
                  //   }
                  // }


                  resolve(queue);

                case 6:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }()); // return await Promise.all(queue)
      // return queue
    },
    exportdata: function exportdata() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var AllList, columns, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.exportLoading = true;
                _context2.next = 3;
                return _this3.exportAll();

              case 3:
                AllList = _context2.sent;
                _this3.exportLoading = false;
                console.log(AllList);
                AllList.forEach(function (item) {
                  item.timestamp = _this3.$times.timestampToTime(item.timestamp);

                  var _loop = function _loop(k) {
                    item[k] = "";
                    item.resource[k].forEach(function (a, index) {
                      item[k] += "".concat(a.item_name, ":").concat(a.item_num).concat(index != item.resource[k].length - 1 ? "," : "");
                    });
                  };

                  for (var k in item.resource) {
                    _loop(k);
                  }
                });
                columns = [{
                  label: _this3.$t('deviceId'),
                  prop: 'device_id_str'
                }, {
                  label: _this3.$t('userId'),
                  prop: 'user_id_str'
                }, {
                  label: _this3.$t('roleId'),
                  prop: 'role_id'
                }, {
                  label: _this3.$t('accountRegisterTime'),
                  prop: 'user_register_time'
                }, {
                  label: _this3.$t('roleCreateTime'),
                  prop: 'role_register_time'
                }, {
                  label: 'ext',
                  prop: 'ext'
                }, {
                  label: _this3.$t('costLabel'),
                  prop: 'cost'
                }, {
                  label: _this3.$t('resourceOutputLabel'),
                  prop: 'output'
                }, {
                  label: _this3.$t('retention'),
                  prop: 'retain'
                }, {
                  label: _this3.$t('ip'),
                  prop: 'ip'
                }, {
                  label: _this3.$t('operation'),
                  prop: 'action_name'
                }, {
                  label: _this3.$t('time'),
                  prop: 'new_date'
                } // {
                //   label: '资源ID',
                //   prop: 'resource_name'
                // },
                // {
                //   label: '变动类型',
                //   prop: 'kind'
                // },
                // {
                //   label: '变动数量',
                //   prop: 'num'
                // },
                // {
                //   label: '资源剩余',
                //   prop: 'resource_surplus'
                // }
                ];
                data = AllList;

                _this3.$export.excel({
                  columns: columns,
                  data: data,
                  title: _this3.$route.meta.title
                });

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};